var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-toolbar",
        [
          _c("v-toolbar-side-icon"),
          _vm._v(" "),
          _c("v-toolbar-title", [_vm._v("Tree Chart")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "menu-item",
              staticStyle: { "margin-left": "32px" },
              attrs: {
                to: _vm.Cons.CANVAS_TREE,
                text: "",
                color: _vm.selectedMenu === "canvas" ? "info" : "",
              },
              on: {
                click: function ($event) {
                  return _vm.to(_vm.Cons.CANVAS_TREE)
                },
              },
            },
            [_vm._v("Canvas Chart")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "menu-item",
              attrs: {
                color: _vm.selectedMenu === "svg" ? "info" : "",
                to: _vm.Cons.SVG_TREE,
                text: "",
                normal: "",
              },
              on: {
                click: function ($event) {
                  return _vm.to(_vm.Cons.SVG_TREE)
                },
              },
            },
            [_vm._v("Svg Chart")]
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            { staticClass: "hidden-sm-and-down" },
            [
              _c(
                "v-btn",
                { attrs: { flat: "", href: "https://github.com/ssthouse" } },
                [
                  _c("v-avatar", { attrs: { size: "42" } }, [
                    _c("img", {
                      attrs: {
                        src: "https://avatars3.githubusercontent.com/u/10973821?s=460&v=4",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "8px" } }, [
                    _vm._v("About me"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    flat: "",
                    href: "https://github.com/ssthouse/organization-chart",
                  },
                },
                [
                  _c("v-avatar", { attrs: { size: "42" } }, [
                    _c("img", {
                      attrs: {
                        src: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
                      },
                    }),
                  ]),
                  _vm._v("\n        Source Code"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", { staticStyle: { width: "100%", height: "100%" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }